import React, { useState, useEffect } from 'react';
import CookieConsent from './components/CookieConsent/CookieConsent';
import GlobalStyles from './style/GlobalStyle';
import HomeContainer from './components/Home/HomeContainer';
import Header from './components/Header/Header';
import AboutMe from './components/AboutMe/AboutMe';
import Contact from './components/Contact/Contact';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import Legals from './components/Legals/Legals';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import smoothscroll from 'smoothscroll-polyfill';
import Taskly from './components/Work/CaseStudies/Taskly/TasklyContainer';
import Kaenguru from './components/Work/CaseStudies/Kaenguru/KaenguruContainer';
import Abcfinlab from './components/Work/CaseStudies/Abc/AbcContainer';

// kick off the polyfill!
smoothscroll.polyfill();

function App() {
  const [prevScrollY, setScrollY] = useState(window.pageYOffset);
  const [visible, setVisible] = useState(true);
  // const [visibleCookie, setVisibleCookie] = useState(true);

  // const cookieTimer = () => {
  //   setTimeout(() => {
  //     setVisibleCookie(false);
  //   }, 6000);
  // };

  function scrollHeader() {
    const currentScrollY = window.pageYOffset;

    if (currentScrollY <= 56) {
      setVisible(true);
    } else if (prevScrollY > currentScrollY) {
      setVisible(true);
    } else {
      setVisible(false);
    }
    setScrollY(window.pageYOffset);
  }

  // useEffect(() => {
  //   cookieTimer();
  // }, []);

  useEffect(() => {
    function watchScroll() {
      window.addEventListener('scroll', scrollHeader);
    }
    watchScroll();
    // Remove listener (like componentWillUnmount)
    return () => {
      window.removeEventListener('scroll', scrollHeader);
    };
  });

  useEffect(() => {
    document.addEventListener('touchstart', function() {}, false);
    return () => {
      document.removeEventListener('touchstart', function() {}, false);
    };
  });

  return (
    <Router>
      <GlobalStyles />
      <>
        <Header visible={visible} />
        <CookieConsent />
        <Switch>
          <Route exact={true} path="/" component={HomeContainer} />
          <Route path="/contact" component={Contact} />
          <Route path="/about" component={AboutMe} />
          <Route path="/privacy-policy" component={PrivacyPolicy} />
          <Route path="/legals" component={Legals} />
          <Route path="/work/taskly" component={Taskly} />
          <Route path="/work/kaenguru" component={Kaenguru} />
          <Route path="/work/abcfinlab" component={Abcfinlab} />
        </Switch>
      </>
    </Router>
  );
}

export default App;
